import React from 'react';
import { Link } from 'react-router-dom';
import {
  FOOTER_LINKS,
  RELEASE_LABEL,
  RELEASE_MANIFEST_PATH,
  SOCIAL_LINKS,
  STUDIO,
  SUPPORT_EMAIL,
} from '../data/siteContent';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer" data-testid="footer">
      <div className="wrap">
        <div className="footer-grid">
          <div className="footer-brand-col">
            <Link to="/" className="brand">{STUDIO.name}</Link>
            <p className="footer-tagline">{STUDIO.supportingStatement}</p>
            <div className="footer-social">
              {SOCIAL_LINKS.map(({ href, label, icon }) => (
                <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
                  <i className={`fab ${icon}`}></i>
                </a>
              ))}
            </div>
          </div>
          <div className="footer-col">
            <h6>Products</h6>
            {FOOTER_LINKS.products.map(({ to, label }) => (
              <Link key={to} to={to}>{label}</Link>
            ))}
          </div>
          <div className="footer-col">
            <h6>Company</h6>
            {FOOTER_LINKS.company.map(({ to, label }) => (
              <Link key={to} to={to}>{label}</Link>
            ))}
          </div>
          <div className="footer-col">
            <h6>Legal</h6>
            {FOOTER_LINKS.legal.map(({ to, label }) => (
              <Link key={to} to={to}>{label}</Link>
            ))}
          </div>
        </div>
        <div className="footer-bottom">
          <span>&copy; {year} {STUDIO.name}. All rights reserved.</span>
          <span>
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
            {' '}&middot;{' '}
            <a href={RELEASE_MANIFEST_PATH} data-testid="release-marker">{RELEASE_LABEL}</a>
          </span>
        </div>
      </div>
    </footer>
  );
}
